module.exports = __webpack_public_path__ + "img/booth-curtain.ed6208e5.svg";